import classnames from 'classnames'
import React from 'react'

const sizes = {
  xs: {
    width: 10,
    height: 10,
    borderWidth: 2
  },
  sm: {
    width: 15,
    height: 15,
    borderWidth: 2
  },
  md: {
    width: 20,
    height: 20,
    borderWidth: 2
  },
  lg: {
    width: 32,
    height: 32,
    borderWidth: 4
  }
}

type SIZES_TYPE = keyof typeof sizes

interface SpinnerProps {
  size?: SIZES_TYPE
  className?: string
}

export const Spinner = ({ size = 'lg', className }: SpinnerProps) => (
  <div className='flex justify-center'>
    <div
      style={{ borderTopColor: 'transparent', width: sizes[size].width, height: sizes[size].height, borderWidth: sizes[size].borderWidth }}
      className={classnames('animate-spin rounded-full border-solid', className)}
    />
  </div>
)
